import { Box } from '@chakra-ui/react';
import { Grid } from '@time-line/components/common';
import { useEffect } from 'react';

export interface FrontrowMDTestimonialsProps {
  id: string;
}

export const FrontrowMDTestimonials = ({ id }: FrontrowMDTestimonialsProps) => {
  useEffect(() => {
    if (!id) return;

    const existing = Array.from(
      document.head.querySelectorAll<HTMLScriptElement>(
        'script[data-frontrow-product-id][data-frontrow-presentation="qual"]',
      ),
    );
    if (existing.some((el) => el.dataset.frontrowProductId === id)) {
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.dataset.frontrowProductId = id;
    script.dataset.frontrowPresentation = 'qual';
    script.src = `https://app.thefrontrowhealth.com/api/widgets/script?presentation_type=qual&product_id=${encodeURIComponent(id)}`;

    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [id]);

  return (
    <Grid className="section--fr-testimonials">
      <Box
        as="iframe"
        gridColumn="main"
        title="frontrow-testimonials"
        id="frontrow-testimonials"
        className="iframe-frontrow-testimonials"
        frameBorder="0"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
        src={`https://app.thefrontrowhealth.com/api/widgets?presentation_type=qual&product_id=${encodeURIComponent(id)}`}
        width="100%"
        sx={{
          '.iframe-frontrow-testimonials': {
            width: '100%',
          },
          '.iframe-modal-testimonials': {
            zIndex: 99999998,
          },
        }}
      />
    </Grid>
  );
};
